import styled from 'styled-components'

const Wrapper = styled.nav`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
  background: var(--clr-pastel-lavender);
  box-shadow: var(--dark-shadow);
  .nav-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .nav-btn {
    font-size: 1.5rem;
    color: var(--clr-light-black);
    background: transparent;
    border-color: transparent;
    transition: var(--transition);
    cursor: pointer;
    padding-top: 0.9rem;
    padding-bottom: 0.9rem;
    padding: 0.9rem 1rem;
  }
  .nav-btn:hover {
    color: var(--clr-black);
  }
  .active-nav-btn {
    transform: rotate(90deg);
  }
  .nav-items {
    list-style-type: none;
    max-height: 0;
    overflow: hidden;
    transition: var(--transition);
  }

  .nav-link {
    color: var(--clr-old-lavender-dark);
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: var(--spacing);
    font-weight: bold;
    display: block;
    padding: 0.5rem 2rem;
    transition: var(--transition);
  }
  .nav-link:hover {
    background: var(--clr-pastel-lavender-dark);
    padding-left: 2.5rem;
  }
  .dropdown .nav-link:hover {
    /* !NEW */
    padding-left: 2rem;
  }
  .nav-link.active {
    background: var(--clr-pastel-lavender-darkest);
    padding-left: 2.5rem;
  }
  .show-items {
    max-height: 20rem;
  }

  /* ! NEW*/
  /* Dropdown container - needed to position the dropdown content */
  .dropdown {
    /* !!! float: left; */
    float: left;
    overflow: hidden;
  }

  /* !! may need to edit for bigger screen */
  .dropdown {
    float: none;
  }
  .dropdown-content {
    position: relative;
  }
  /* Style the dropdown button to fit inside the topnav */
  .dropdown .dropbtn {
    /* font-size: 17px; */
    border: none;
    outline: none;
    /* color: white; */
    /* ! padding: 14px 16px; */
    background-color: inherit;
    font-family: inherit;
    /* min-width: 100vw; */
    /* margin: 0; */
    /* !! */
    display: block;
    width: 100%;
    text-align: left;
  }

  .dropdown .dropbtn-active {
    background-color: var(--clr-pastel-lavender-dark);
  }

  /* Style the dropdown content (hidden by default) */
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    /* background-color: currentColor; */
    min-width: 160px;
    min-width: 100vw;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }
  .drop-down-link:hover {
    /* background: var(--clr-pastel-lavender-dark); */
    padding-left: 2.5rem;
  }
  .drop-down-link.active {
    /* background: var(--clr-pastel-lavender-darkest); */
    padding-left: 2.5rem;
  }

  /* Style the links inside the dropdown */
  /* .dropdown-content a { */
  .dropdown-content .drop-down-link {
    float: none;
    color: var(--clr-light-black);
    color: var(--clr-old-lavender-dark);
    background-color: white;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    text-align: left;
    /* NEW */
    letter-spacing: var(--spacing);
    letter-spacing: 0.1rem;
    font-weight: 500;
    padding-left: 2rem;
    /* text-transform: uppercase; */
    /* font-weight: bold; */
    /* display: block; */
    /* padding: 0.5rem 2rem; */
    transition: var(--transition);
  }
  /* NEW */
  .dropdown-content .drop-down-link {
    padding-left: 2.5rem;
  }
  .dropdown-content .drop-down-link:hover {
    /* NEW */
    /* padding-left: 2.5rem; */
    padding-left: 3rem;
  }
  .dropdown-content .drop-down-link.active {
    /* NEW */
    /* padding-left: 2.5rem; */
    padding-left: 3rem;
  }

  /* Add a dark background on topnav links and the dropdown button on hover */
  .topnav a:hover,
  .dropdown:hover .dropbtn {
    /* background-color: #555; */
    background: var(--clr-pastel-lavender-dark);
    /* color: white; */
  }

  /* Add a grey background to dropdown links on hover */
  .dropdown-content a:hover {
    /* background-color: #ddd;
    background-color: var(--clr-pastel-lavender-light); */
    background-color: #555;
    /* background-color: var(--clr-old-lavender-dark); */
    /* color: black; */
    color: white;
  }
  /* .dropdown-content a.active { */
  .dropdown-content .drop-down-active {
    background-color: #8a8a8a;
    background-color: var(--clr-old-lavender-dark);
    /* background-color: var(--clr-old-lavender); */
    /* color: var(--clr-pastel-lavender-light); */
    color: white;
  }

  /* Show the dropdown menu when the user moves the mouse over the dropdown button */
  /* !old */
  /*.dropdown:hover .dropdown-content {
    display: block;
  } */
  .is-hovering {
    display: block;
  }
  .close-drop-down {
    /* display: none; */
  }

  /* When the screen is less than 600 pixels wide, hide all links, except for the first one ("Home"). Show the link that contains should open and close the topnav (.icon) */
  /* @media screen and (max-width: 600px) {
    .topnav a:not(:first-child),
    .dropdown .dropbtn {
      display: none;
    }
    .topnav a.icon {
      float: right;
      display: block;
    }
  } */

  /* The "responsive" class is added to the topnav with JavaScript when the user clicks on the icon. This class makes the topnav look good on small screens (display the links vertically instead of horizontally) */
  /* @media screen and (max-width: 600px) {
    .topnav.responsive {
      position: relative;
    }
    .topnav.responsive a.icon {
      position: absolute;
      right: 0;
      top: 0;
    }
    .topnav.responsive a {
      float: none;
      display: block;
      text-align: left;
    }
    .topnav.responsive .dropdown {
      float: none;
    }
    .topnav.responsive .dropdown-content {
      position: relative;
    }
    .topnav.responsive .dropdown .dropbtn {
      display: block;
      width: 100%;
      text-align: left;
    }
    .topnav.responsive .dropdown .dropbtn {
      display: block;
      width: 100%;
      text-align: left;
    }
  } */

  /* ! END NEW */

  @media screen and (min-width: 826px) {
    .nav-center {
      max-width: 1170px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .nav-btn {
      display: none;
    }
    .nav-items {
      max-height: fit-content;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .nav-link {
      letter-spacing: var(--spacing-smaller);
      padding: 0.9rem;
      padding: 1.2rem;
    }
    .nav-link:hover {
      padding: 1.2rem;
    }
    .nav-link.active {
      padding: 1.2rem;
    }
    .flex-container {
      justify-content: space-between;
    }
    /* NEW */
    .dropdown-content {
      min-width: 160px;
    }
    .dropdown .nav-link:hover {
      /* !NEW */
      padding-left: 1.2rem;
    }
    /* NEW */
    .dropdown-content .drop-down-link {
      padding-left: 2rem;
    }
    .dropdown-content .drop-down-link:hover {
      /* NEW */
      padding-left: 2rem;
    }
    .dropdown-content .drop-down-link.active {
      /* NEW */
      padding-left: 2rem;
    }
    /* .drop-down-link:hover {
      padding: 0rem;
    } */
  }
`
export default Wrapper
